import { environment } from 'environments/environment';
import { EditRelationshipComponent } from './../editrelationship/edit-relationship.component';
import { UBOComponent } from 'app/entities/relations/relationship/ubo/ubo.component';
import { ConfirmDeleteRelationshipComponent } from './confirmdeleterelationship/confirmdeleterelationship.component';
import { RelationshipDiagramComponent } from './relationship-diagram/relationship-diagram.component';
import { Router } from '@angular/router';
import { EntityDetailsService } from './../../details/entity-details.service';
import {
  EntityRelationsService,
  RelationshipPanelActions
} from 'app/entities/relations/entity-relations.service';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { AddRelationComponent } from 'app/entities/relations/relationship/addrelation/add-relation.component';
import { ImportRelationComponent } from 'app/entities/relations/relationship/import-relation/import-relation.component';
import { EntityRelation } from '../../../shared/models/entity-relation.model';
import { relationListLimit, relationsNamed } from 'app/entities/relations/relation-list.util';
import { ConstantsService } from 'app/services/constants-service';

/**
 * Main module for the relationship management.
 *
 * @author raj.sharma@vernuso.com (Rajendra Sharma)
 */
@Component({
  selector: 'relationship',
  templateUrl: './relationship.component.html',
  styleUrls: ['./relationship.component.css']
})
export class RelationshipComponent implements OnInit {
  entityIdDetails: EntityIdDetails;
  relationships: EntityRelation[] = [];
  numberOfRelationship = 0;
  dialogRef: MdDialogRef<any>;
  isLoading = false;
  expend: any;
  personLogo = ConstantsService.DEFAULT_PERSON_MALE_LOGO;
  orgLogo = ConstantsService.DEFAULT_ORG_LOGO;
  maxRecordsToBeDisplayed = 10;
  currentRelationShipRecords = 0;
  enableExecutiveSummary = environment.enableExecutiveSummary;
  isRecordNumberMoreThanLimit: Boolean;
  searchFilter = '';
  searchSource: EntityRelation[] = null;
  private searchLoadStarted = false;

  constructor(public entityRelationsService: EntityRelationsService,
    private entityDetailsService: EntityDetailsService,
    private viewContainerRef: ViewContainerRef,
    private dialog: MdDialog) {
  }

  ngOnInit() {
    this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();
    if (this.entityIdDetails.entityId) {
      this.loadRelationships();
    } else {
      this.entityDetailsService.entityDetailsUpdated.subscribe(
        (entityDetails) => {
          this.entityIdDetails = entityDetails;
          this.loadRelationships();
        }
      );
    }
    this.entityRelationsService.currentMessage.subscribe(message => {
      if (message === RelationshipPanelActions.UPDATE_RELATIONSHIPS.toString()) {
        this.loadRelationships();
      }
      if (message === RelationshipPanelActions.LOADING_FILE.toString()) {
        this.isLoading = true;
      }
      if (message === RelationshipPanelActions.STOP_LOADING_FILE.toString()) {
        this.isLoading = false;
      }
    });
  }

  public loadRelationships() {
    this.entityRelationsService.getRelationshipsWithOffsetAndLimits(this.entityIdDetails.entityId,
      this.currentRelationShipRecords, this.maxRecordsToBeDisplayed).subscribe(
      response => {
        const newRelationShips = this.getNewRelationShipsFromResponse(response);
        this.relationships.push.apply(this.relationships, newRelationShips);
        this.numberOfRelationship = response.arrResult.totalRecords;
        this.isRecordNumberMoreThanLimit = this.numberOfRelationship > this.maxRecordsToBeDisplayed;
      });
  }

  openRelationShipDiagram() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(RelationshipDiagramComponent, config);
    this.dialogRef.componentInstance.entityId = this.entityIdDetails.entityId;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
    });
  }

  openUBOPanel() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(UBOComponent, config);
    this.dialogRef.componentInstance.entityId = this.entityIdDetails.entityId;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
    });
  }

  confirmDelete(relationship) {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(ConfirmDeleteRelationshipComponent, config);
    this.dialogRef.componentInstance.relationshipId = relationship.id;
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.relationships = this.relationships.filter(item => {
          return relationship.id !== item.id;
        });
      }
      this.dialogRef = null;
    });
  }

  openAddRelationDialog(relationship) {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(AddRelationComponent, config);
    this.dialogRef.componentInstance.entityIdDetails = this.entityIdDetails;
    this.dialogRef.componentInstance.selectedRelation = relationship;
    this.dialogRef.componentInstance.action = relationship && 'Edit' || 'Add';
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadRelationships();
      }
      this.dialogRef = null;
    });
  }

  openImportRelationDialog() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(ImportRelationComponent, config);
    this.dialogRef.componentInstance.entityId = this.entityIdDetails.entityId;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
    });
  }

  showDetail(i) {
    if (this.expend === i) {
      this.expend = null;
    } else {
      this.expend = i;
    }
  }

  onScrollDown() {
    if (this.searchFilter) {
      return;
    }
    if ((this.currentRelationShipRecords + this.maxRecordsToBeDisplayed) < this.numberOfRelationship) {
      this.currentRelationShipRecords += this.maxRecordsToBeDisplayed;
      this.loadRelationships();
    }
  }

  onRelationSearch(value: string) {
    this.searchFilter = (value || '').trim().toLowerCase();
    if (!this.searchFilter || !this.entityIdDetails || !this.entityIdDetails.entityId) {
      return;
    }
    const loaded = this.searchSource ? this.searchSource.length : this.relationships.length;
    if (!this.searchLoadStarted && (this.searchSource == null || loaded < this.numberOfRelationship)) {
      this.searchLoadStarted = true;
      this.loadAllRelationsForSearch();
    }
  }

  get visibleRelationships(): EntityRelation[] {
    if (!this.searchFilter) {
      return this.relationships;
    }
    return relationsNamed(this.searchSource || this.relationships, this.searchFilter);
  }

  private loadAllRelationsForSearch() {
    const limit = relationListLimit(this.numberOfRelationship);
    this.isLoading = true;
    this.entityRelationsService.getRelationshipsWithOffsetAndLimits(
      this.entityIdDetails.entityId, 0, limit).subscribe(response => {
        const rows = (response && response.arrResult && response.arrResult.relations) || [];
        this.searchSource = rows;
        this.numberOfRelationship = (response && response.arrResult && response.arrResult.totalRecords) || rows.length;
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
      });
  }

  openEditRelationDialog(relation: EntityRelation, commentType: string, text) {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(EditRelationshipComponent, config);
    this.dialogRef.componentInstance.comment = text;
    this.dialogRef.componentInstance.relation = relation;
    this.dialogRef.componentInstance.commentType = commentType;
    this.dialogRef.componentInstance.entityId = this.entityIdDetails.entityId;
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadRelationships();
      }
    });
  }

  private getNewRelationShipsFromResponse(response) {
    if (this.relationships.length == 0) {
      return response.arrResult.relations;
    }
    const temporaryMapForCurrentRelationship: { [key: number]: EntityRelation; } = {};
    this.relationships.forEach(item => {
      temporaryMapForCurrentRelationship[item.id] = item;
    });
    const newRelationShips = response.arrResult.relations.filter(item => {
      const isExists
        = temporaryMapForCurrentRelationship[item.id] == null
        || temporaryMapForCurrentRelationship[item.id].role !== item.role
        || temporaryMapForCurrentRelationship[item.id].meta !== item.meta;
      if (isExists) {
        const relation = this.relationships.find(relationCheck => {
          return relationCheck.id === item.id;
        });
        if (relation) {
          this.relationships.splice(this.relationships.indexOf(relation), 1);
        }
      }
      return isExists;
    });
    return newRelationShips;
  }

  isPersonOrOrganisation(relationship) {
    return relationship.entityType === 'PERSON'
      || relationship.entityType === 'ORGANISATION';
  }

  isClient(relationship) {
    return relationship.entityType === 'CLIENT';
  }

  isUBOOrPEP(relationship) {
    return relationship.entityType === 'PERSON' && (relationship.ubo || relationship.pep);
  }

  getOriginOfFundsLabel(relationship) {
    return this.isUBOOrPEP(relationship) ? 'Source of Wealth' : 'Origin of Funds';
  }
}




// WEBPACK FOOTER //
// ./src/app/entities/relations/relationship/relationship.component.ts